<div id="partner-details">
    <ng-container *ngIf="!isLoggedInTokenValid">
        <div class="row">
            <div class="mx-auto">
                <img src="/ocrp-rewards-ui/dist/assets/images/busy.gif"
                     style="width:100px;height:100px;margin: 50px 0px 0px 0px;" alt="">
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="isLoggedInTokenValid">
        <app-promotion-hero [isWebView]="isWebView" [partnerDetails]="partnerDetails" (partnerRedeemObject)="getPartnerRedeemObject($event)"></app-promotion-hero>
    </ng-container>
</div>
